

export function tokeep(content,digits) {  //num 为返回值，digits需要保留小数点的位数
	if(typeof(content) == 'number'){
		var x = String(content).indexOf('.') + 1;   //小数点的位置
		var y = String(content).length - x;         //小数的位数
		if(y>digits){
			return content.toFixed(digits)
		}else{
			return content
		}
		return content.toFixed(digits)
	}else{
		return content
	}
};


// 校验手机号
export function checkPhone(phone){ 
    if(/^1\d{10}$/.test(phone)){  
        return true; 
    } 
}

// 校验身份证
export function isCardNo(card) 
{ 
  // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X 
  var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/; 
  return reg.test(card)
}

// 校验邮箱
export function checkemail(email) 
{  
  var reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return reg.test(email)
}


// 校验是否为空对象
export function isEmpty(obj) {
    //检验null和undefined
    if (!obj && obj !== 0 && obj !== '') {
        return true;
    }
    //检验数组
    if (Array.prototype.isPrototypeOf(obj) && obj.length === 0) {
        return true;
    }
    //检验对象
    if (Object.prototype.isPrototypeOf(obj) && Object.keys(obj).length === 0) {
        return true;
    }
    return false;
}


export function dateFormat(date,fmt){
	if(date === null) {
		date = 0
	}
	if(date.replace){
		date =new Date(date.replace(/[-]/g,"/"))
	}
	if(!(date instanceof Date)){
		date = new Date(date)
	}
	var o = {
		"M+" : date.getMonth() + 1,
		"d+" : date.getDate(),
		"h+" : date.getHours(),
		"m+" : date.getMinutes(),
		"s+" : date.getSeconds(),
		"q+" : Math.floor((date.getMonth() + 3) / 3),
		"S" : date.getMilliseconds()
	};
	if (/(y+)/.test(fmt))
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
	for (var k in o)
	if (new RegExp("(" + k + ")").test(fmt))
		fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
	return fmt;
}

//日期输出，为了 兼容不同手机JS环境
export function dateFormatByString(){
	
}

//对象转换
export function getDateObj(time){
	return new Date(time.replace(/[-]/g,"/"))
}


//获取日
export function getDate(time){
	time = new Date(time.replace(/[-]/g,"/"))
	return dateFormat(time,"dd")
}

//获取月份
export function getMon(time){
	time =new Date(time.replace(/[-]/g,"/"))
	return dateFormat(time,"MM")
}

//数据转化  
export function formatNumber(n) {  
    n = n.toString()  
    return n[1] ? n : '0' + n  
}  
/** 
* 时间戳转化为年 月 日 时 分 秒 
* timestamp: 传入时间戳
* format：返回格式，支持自定义，但参数必须与formateArr里保持一致 
*/  
export function formatTime(timestamp,format) {  
    //console.log('打印',timestamp)
    var formateArr  = ['Y','M','D','h','m','s','day']
    var returnArr   = []
    if(timestamp !== undefined ){
        var unit = timestamp.length == 10 ? 1000 : 1
    }
    
    var date = new Date(parseInt(timestamp)*unit);
    returnArr.push(date.getFullYear())
    returnArr.push(formatNumber(date.getMonth() + 1))
    returnArr.push(formatNumber(date.getDate()))
    returnArr.push(formatNumber(date.getHours()))
    returnArr.push(formatNumber(date.getMinutes())) 
    returnArr.push(formatNumber(date.getSeconds()))
    returnArr.push(date.getDate())
    for (var i = 0; i < returnArr.length; i++) {
        format = format.replace(formateArr[i], returnArr[i])
    }
    return format;  
}

export function formatleftday(timestamp){
	if(timestamp !== undefined ){
        var unit = timestamp.length == 10 ? 1000 : 1
    }
    timestamp  = (timestamp)*unit

	return timestamp / (1000*3600*24)
    // var time = parseInt(second_time) + "秒";
    // if (parseInt(second_time) > 60) {

    //     var second = parseInt(second_time) % 60;
    //     var min = parseInt(second_time / 60);
    //     time = min + "分" + second + "秒";

    //     if (min > 60) {
    //         min = parseInt(second_time / 60) % 60;
    //         var hour = parseInt(parseInt(second_time / 60) / 60);
    //         time = hour + "小时" + min + "分" + second + "秒";

    //         if (hour > 24) {
    //             hour = parseInt(parseInt(second_time / 60) / 60) % 24;
    //             var day = parseInt(parseInt(parseInt(second_time / 60) / 60) / 24);
    //             if (day > 0) {
    //                 time = day + "天" + hour + "小时" + min + "分";
    //             } else {
    //                 time = day + "天" + hour + "小时" + min + "分" + second + "秒";
    //             }


    //         }
    //     }


    // }

    // return time;
    
}

export function setfixtimeCookie(key,value) { //设置cookie 有效期一天
	var exdate = new Date(); //獲取時間
	var timestampend = new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1)
	// console.log('star',exdate.getTime())
	// console.log('end',timestampend.getTime())
	// console.log(timestampend.getTime() - exdate.getTime())
    exdate.setTime(timestampend.getTime()); //保存的天數，我這裡寫的是100年
    //字符串拼接cookie
    window.document.cookie = key + "=" + value + ";path=/;expires=" + exdate.toGMTString();
};


//設置cookie
export function setCookie(key,value) {
    var exdate = new Date(); //獲取時間
    exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * 36500); //保存的天數，我這裡寫的是100年
    //字符串拼接cookie
    window.document.cookie = key + "=" + value + ";path=/;expires=" + exdate.toGMTString();
};
//讀取cookie
export function getCookie(param) {
    var c_param = '';
    if (document.cookie.length > 0) {
      var arr = document.cookie.split('; '); //這裡顯示的格式需要切割一下自己可輸出看下
      for (var i = 0; i < arr.length; i++) {
        var arr2 = arr[i].split('='); //再次切割
        //判斷查找相對應的值
        if (arr2[0] == param) {
          c_param = arr2[1];
          //保存到保存數據的地方
        }
      }
      return c_param;
    }
};
export function padLeftZero (str) {
    return ('00' + str).substr(str.length);
};


export function getMaxSort(arr) {
    return arr.sort((a, b) => a - b).slice().pop();
}

//判断小数点后是否保留2位
export function isTwoBitDecimal(value) {
    var rex =/\d+[.]\d{2}/g
    var s = value ;
    if(s.test(rex)) 
        return true;
    else{
        return false;
    }
};



/**
 * 把秒数转化为天、时、分、秒
 * 参数value是秒数
 */
export function formatSeconds(value) {
    var secondTime = parseInt(value) // 秒
    var minuteTime = 0 // 分
    var hourTime = 0 // 小时
    var dayTime = 0 // 天
    var result = ''
    if (value < 60) {
        result = secondTime + '秒'
    } else {
        if (secondTime >= 60) { // 如果秒数大于60，将秒数转换成整数
            // 获取分钟，除以60取整数，得到整数分钟
            minuteTime = parseInt(secondTime / 60)
            // 获取秒数，秒数取佘，得到整数秒数
            secondTime = parseInt(secondTime % 60)
            // 如果分钟大于60，将分钟转换成小时
            if (minuteTime >= 60) {
                // 获取小时，获取分钟除以60，得到整数小时
                hourTime = parseInt(minuteTime / 60)
                // 获取小时后取佘的分，获取分钟除以60取佘的分
                minuteTime = parseInt(minuteTime % 60)
                if (hourTime >= 24) {
                    // 获取天数， 获取小时除以24，得到整数天
                    dayTime = parseInt(hourTime / 24)
                    // 获取小时后取余小时，获取分钟除以24取余的分；
                    hourTime = parseInt(hourTime % 24)
                }
            }
        }
        
        if (secondTime > 0 && (dayTime <= 0)) {
            secondTime = parseInt(secondTime) >= 10 ? secondTime : '0' + secondTime
            result = '' + secondTime + '秒'
        }
        
        if (minuteTime > 0) {
            minuteTime = parseInt(minuteTime) >= 10 ? minuteTime : '0' + minuteTime
            result = '' + minuteTime + '分' + result
        }
        if (hourTime > 0) {
            result = '' + parseInt(hourTime) + '小时' + result
        }
        if (dayTime > 0) {
            result = '' + parseInt(dayTime) + '天' + result
        }
        
        
    }
    return result
}